export default {
  "--color-default": "rgb(12, 57, 68)",
  "--color-default-inverse": "rgb(255, 255, 255)",
  "--color-primary": "rgb(25, 108, 132)",
  "--color-primary-active": "rgb(32, 136, 167)",
  "--color-primary-inverse": "rgb(255, 255, 255)",
  "--color-secondary": "rgb(255, 243, 13)",
  "--color-secondary-active": "rgb(244, 232, 4)",
  "--color-secondary-inverse": "rgb(12, 57, 68)",
  "--color-tertiary": "rgb(155, 8, 79)",
  "--color-tertiary-active": "rgb(193, 11, 99)",
  "--color-tertiary-inverse": "rgb(255, 255, 255)",
  "--color-sahara-sand": "rgb(252, 246, 160)",
  "--color-flame-pea": "rgb(243, 151, 107)",
  "--color-roman": "rgb(227, 97, 100)",
  "--color-cerise": "rgb(155, 8, 79)",
  "--color-atlantis": "rgb(193, 233, 78)",
  "--color-calypso": "rgb(25, 108, 132)",
  "--color-blue-dianne": "rgb(12, 57, 68)",
  "--color-silver-tree": "rgb(112, 175, 144)",
  "--color-zeus": "rgb(71, 65, 54)",
  "--color-brick-red": "rgb(198, 46, 67)",
  "--color-parsley": "rgb(36, 103, 58)",
  "--color-broom": "rgb(255, 243, 13)",
  "--color-beach": "rgb(248, 246, 240)",
  "--color-coraline": "rgb(255, 109, 95)",
  "--color-coraline-dark": "rgb(106, 45, 39)",
  "--color-mint": "rgb(0, 207, 193)",
  "--color-mint-dark": "rgb(1, 60, 56)",
  "--color-punk": "rgb(56, 67, 208)",
  "--color-punk-dark": "rgb(20, 24, 75)",
  "--color-peppa-pig": "rgb(251, 131, 171)",
  "--color-sun": "rgb(255, 243, 13)",
  "--color-eggplant": "rgb(59, 30, 58)",
  "--color-dark-nest": "rgb(28, 30, 42)",
  "--color-neutral-0": "rgb(20, 24, 31)",
  "--color-neutral-10": "rgb(31, 39, 50)",
  "--color-neutral-20": "rgb(59, 73, 94)",
  "--color-neutral-30": "rgb(79, 97, 125)",
  "--color-neutral-40": "rgb(88, 109, 141)",
  "--color-neutral-50": "rgb(130, 148, 176)",
  "--color-neutral-60": "rgb(161, 175, 196)",
  "--color-neutral-70": "rgb(192, 202, 216)",
  "--color-neutral-80": "rgb(224, 228, 235)",
  "--color-neutral-85": "rgb(236, 239, 243)",
  "--color-neutral-90": "rgb(242, 244, 247)",
  "--color-neutral-95": "rgb(249, 250, 251)",
  "--color-neutral-100": "rgb(255, 255, 255)",
  "--color-success": "rgb(39, 174, 96)",
  "--color-success-active": "rgb(42, 187, 103)",
  "--color-success-inverse": "rgb(255, 255, 255)",
  "--color-danger": "rgb(217, 58, 58)",
  "--color-danger-active": "rgb(221, 75, 75)",
  "--color-danger-inverse": "rgb(255, 255, 255)",
  "--color-warning": "rgb(230, 121, 25)",
  "--color-warning-active": "rgb(233, 137, 53)",
  "--color-warning-inverse": "rgb(255, 255, 255)",
  "--color-yellow": "rgb(245, 196, 0)",
  "--color-yellow-active": "rgb(255, 206, 10)",
  "--color-yellow-inverse": "rgb(255, 255, 255)",
  "--color-text": "rgb(12, 57, 68)",
  "--color-text-light": "rgb(130, 148, 176)",
  "--color-text-lighter": "rgb(161, 175, 196)",
  "--text-color-disabled": "rgb(192, 202, 216)",
  "--text-color-inverse": "rgb(249, 250, 251)",
  "--text-color-link": "rgb(25, 108, 132)",
  "--text-color-link-active": "rgb(32, 136, 167)",
  "--text-color-primary": "rgb(25, 108, 132)",
  "--text-color-primary-inverse": "rgb(255, 255, 255)",
  "--text-color-secondary": "rgb(255, 243, 13)",
  "--text-color-secondary-inverse": "rgb(12, 57, 68)",
  "--text-color-success": "rgb(39, 174, 96)",
  "--text-color-success-inverse": "rgb(255, 255, 255)",
  "--text-color-warning": "rgb(230, 121, 25)",
  "--text-color-warning-inverse": "rgb(255, 255, 255)",
  "--text-color-danger": "rgb(217, 58, 58)",
  "--text-color-danger-inverse": "rgb(255, 255, 255)",
  "--background-color-base": "rgb(255, 255, 255)",
  "--background-color-soft": "rgb(249, 250, 251)",
  "--background-color-softer": "rgb(242, 244, 247)",
  "--background-color-softer-active": "rgb(249, 250, 251)",
  "--background-color-softest": "rgb(236, 239, 243)",
  "--background-color-softest-active": "rgb(242, 244, 247)",
  "--background-color-inverse": "rgb(20, 24, 31)",
  "--background-color-inverse-soft": "rgb(31, 39, 50)",
  "--background-color-inverse-softer": "rgb(59, 73, 94)",
  "--background-color-inverse-softer-active": "rgb(79, 97, 125)",
  "--background-color-disabled": "rgb(242, 244, 247)",
  "--background-color-primary": "rgb(25, 108, 132)",
  "--background-color-primary-active": "rgb(32, 136, 167)",
  "--background-color-primary-inverse": "rgb(255, 255, 255)",
  "--background-color-secondary": "rgb(255, 243, 13)",
  "--background-color-secondary-active": "rgb(244, 232, 4)",
  "--background-color-secondary-inverse": "rgb(12, 57, 68)",
  "--background-color-success": "rgb(39, 174, 96)",
  "--background-color-success-active": "rgb(42, 187, 103)",
  "--background-color-success-inverse": "rgb(255, 255, 255)",
  "--background-color-warning": "rgb(230, 121, 25)",
  "--background-color-warning-active": "rgb(233, 137, 53)",
  "--background-color-warning-inverse": "rgb(255, 255, 255)",
  "--background-color-danger": "rgb(217, 58, 58)",
  "--background-color-danger-active": "rgb(221, 75, 75)",
  "--background-color-danger-inverse": "rgb(255, 255, 255)",
  "--background-color-input": "rgb(255, 255, 255)",
  "--border-color-base": "rgb(224, 228, 235)",
  "--border-color-soft": "rgb(236, 239, 243)",
  "--border-color-softer": "rgb(242, 244, 247)",
  "--border-color-active": "rgb(25, 108, 132)",
  "--border-color-primary": "rgb(25, 108, 132)",
  "--border-color-success": "rgb(39, 174, 96)",
  "--border-color-warning": "rgb(230, 121, 25)",
  "--border-color-danger": "rgb(217, 58, 58)",
  "--border-width-m": "1px",
  "--border-width-l": "2px",
  "--border-width-xl": "3px",
  "--border-size-base": "1px",
  "--border-size-large": "2px",
  "--border-size-x-large": "3px",
  "--border": "1px solid #eff2f7",
  "--border-radius-s": "2px",
  "--border-radius-m": "10px",
  "--border-radius-l": "20px",
  "--border-radius-xl": "30px",
  "--border-radius-xxl": "50px",
  "--border-radius-full": "1000px",
  "--border-radius-base": "2px",
  "--border-radius-rounded": "10px",
  "--border-radius-circle": "50%",
  "--font-size-xxxxxl": "3rem",
  "--font-size-xxxxl": "2rem",
  "--font-size-xxxl": "1.625rem",
  "--font-size-xxl": "1.5rem",
  "--font-size-xl": "1.4rem",
  "--font-size-l": "1.2rem",
  "--font-size-m": "1.0rem",
  "--font-size-s": "0.875rem",
  "--font-size-xs": "0.75rem",
  "--font-space-xxxxl": "2em",
  "--font-space-xxxl": "1.5em",
  "--font-space-xxl": "1.2em",
  "--font-space-xl": "1em",
  "--font-space-l": "0.6em",
  "--font-space-m": "0.5em",
  "--font-space-s": "0.4em",
  "--font-space-xs": "0.3em",
  "--font-space-xxs": "0.2em",
  "--font-space-xxxs": "0.1em",
  "--font-heading": "Boldonse, Helvetica, Arial, sans-serif",
  "--font-text": "Onest, Helvetica, Arial, sans-serif",
  "--font-code": "inconsolata, monospace",
  "--font-weight-extrablack": "900",
  "--font-weight-black": "800",
  "--font-weight-extrabold": "700",
  "--font-weight-semi-bold": "600",
  "--font-weight-bold": "500",
  "--font-weight-medium": "500",
  "--font-weight-normal": "400",
  "--font-weight-light": "300",
  "--line-height-l": "1.45",
  "--line-height-m": "1.3",
  "--line-height-s": "1.15",
  "--line-height-xs": "1",
  "--line-height-xxs": "0.8",
  "--letter-spacing-x-large": "0.1em",
  "--letter-spacing-large": "0.05em",
  "--letter-spacing-base": "0",
  "--letter-spacing-small": "-0.01em",
  "--letter-spacing-x-small": "-0.015em",
  "--opacity-hover": "0.8",
  "--opacity-soft": "0.65",
  "--opacity-disabled": "0.5",
  "--space-xxxl": "100px",
  "--space-xxl": "60px",
  "--space-xl": "40px",
  "--space-l": "30px",
  "--space-m": "20px",
  "--space-s": "15px",
  "--space-xs": "10px",
  "--space-xxs": "5px",
  "--space-xxxs": "2px",
  "--space-0": "0",
  "--size-height-base": "42px",
  "--size-height-large": "50px",
  "--size-height-xlarge": "60px",
  "--size-tappable-square": "44px",
  "--size-height-footer": "64px",
  "--container-size": "1100px",
  "--container-size-l": "1760px",
  "--box-shadow-s": "0 0 0 1px rgba(92,106,196,.1)",
  "--box-shadow-m": "1px 1px 4px 0 rgba(0, 0, 0, 0.1)",
  "--box-shadow-l": "2px 4px 10px 0 rgba(0, 0, 0, 0.1)",
  "--box-shadow-elevated": "0 0 0 1px rgba(31, 45, 61, 0.08), 0 2px 2px 0 rgba(31, 45, 61, 0.03)",
  "--box-shadow-elevated-l": "0 2px 4px 0 rgba(0, 0, 0, 0.15)",
  "--box-shadow-large": "0 20px 60px 0 rgba(0, 0, 0, .15)",
  "--box-shadow-base": "0px 12px 26px -4px rgba(0, 0, 0, .1)",
  "--box-shadow-small": "0px 8px 18px -2px rgba(0, 0, 0, .1)",
  "--box-shadow-x-small": "0px 0px 3px 0px rgba(0, 0, 0, .1)",
  "--box-shadow-active": "0 0 6px 1px rgba(20, 100, 160, 0.5)",
  "--box-shadow-inset": "inset 0 0 20px 1px rgba(0,0,0,.15)",
  "--box-shadow-small-inset": "inset 0 0 0 1px rgba(0,0,0,.05)",
  "--duration-short": "0.08s",
  "--duration-base": "0.5s",
  "--duration-long": "0.75s",
  "--duration-x-long": "1s",
  "--duration-xx-long": "2s",
  "--ease-out": "cubic-bezier(0.25, 0.46, 0.45, 0.94)",
  "--ease-out-sharp": "cubic-bezier(0.165, 0.84, 0.44, 1)",
  "--ease-out-bounce": "cubic-bezier(.87,-.41,.19,1.44)",
  "--ease-in": "cubic-bezier(0.55, 0.085, 0.68, 0.53)",
  "--ease-in-sharp": "cubic-bezier(0.895, 0.03, 0.685, 0.22)",
  "--z-index-modal": "9999",
  "--z-index-dropdown": "8888",
  "--z-index-page-sidebar": "2500",
  "--z-index-page-submenu": "2000",
  "--z-index-page-header": "1500",
  "--z-index-sticky": "100",
  "--breakpoints": "('small': 767px, 'medium': 992px, 'large': 1200px, 'xlarge': 1550px)",
  "--media-query-s": "'(min-width: 767px)'",
  "--media-query-m": "'(min-width: 992px)'",
  "--media-query-l": "'(min-width: 1200px)'",
  "--xs": "480",
  "--sm": "600",
  "--md": "768",
  "--lg": "1024",
  "--xl": "1200",
  "--media-query-x-small": "'(min-width: 480px)'",
  "--media-query-small": "'(min-width: 600px)'",
  "--media-query-medium": "'(min-width: 768px)'",
  "--media-query-large": "'(min-width: 1024px)'",
  "--media-query-x-large": "'(min-width: 1200px)'"
}